<template>
  <div
    class="d-activity-entry"
    :class="{ 'white': isSocialDisplayed }"
  >
    <div
      class="activity-container"
      :class="{ 'linked': isLinkEnabled }"
      @click="goToActivity"
    >
      <DActivityRepost
        v-if="!!activity.source && !!activity.source.has_repost"
        :activity="activity"
        :is-user-signed-in="!!userAvatarUrl"
        @activity-removed="activityRemoved"
      />

      <DActivityActivity
        v-else
        :activity="activity"
        :is-user-signed-in="!!userAvatarUrl"
        @activity-removed="activityRemoved"
      />
    </div>

    <div
      v-if="isSocialDisplayed"
      class="social-container"
    >
      <DActivityEntrySocial
        :activity="activity"
        :is-user-signed-in="!!userAvatarUrl"
        :num-comments="numComments"
        @post-created="postCreated"
      />

      <DCommentsPanel
        class="space-top-1em"
        :display-heading="false"
        :display-empty-panel="false"
        :item-slug="activity.slug"
        item-type="post"
        :num-displayed-replies="numDisplayedRepliesOnComments"
        :user-avatar-url="userAvatarUrl"
        :user-name="userName"
        @num-comments-updated="numCommentsUpdated"
      />
    </div>
  </div>
</template>

<script>
import DActivityActivity from './d-activity-activity.vue';
import DActivityRepost from './d-activity-repost.vue';
import DCommentsPanel from '@d-components/d-comments-panel/d-comments-panel.vue';
import DActivityEntrySocial from './shared/d-activity-entry-social/d-activity-entry-social.vue';
import { POST_LINK_ENABLED_TYPES, POST_SOCIAL_ENABLED_TYPES } from '@d-shared/config';
import Window from '@d-shared/utils/window';

export default {
  components: {
    DActivityActivity,
    DActivityRepost,
    DCommentsPanel,
    DActivityEntrySocial,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    linkToActivity: {
      type: Boolean,
      default: false,
    },
    numDisplayedRepliesOnComments: {
      type: Number,
      default: 1,
    },
    userAvatarUrl: {
      type: String,
      default: null,
    },
    userName: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    isLinkEnabled: false,
    isSocialDisplayed: false,
    numComments: null,
  }),
  mounted() {
    this.setIsLinkEnabled();
    this.setIsSocialDisplayed();
  },
  methods: {
    activityRemoved() {
      this.$emit('activity-removed', this.activity);
    },

    goToActivity() {
      if (!this.isLinkEnabled) {
        return;
      }

      Window.goTo(this.activity.url);
    },

    numCommentsUpdated(numComments) {
      this.$set(this, 'numComments', numComments);
    },

    postCreated(newPost) {
      this.$emit('post-created', newPost);
    },

    setIsLinkEnabled() {
      if (!this.linkToActivity) {
        return;
      }

      if (POST_LINK_ENABLED_TYPES.indexOf(this.activity.type) === -1) {
        return;
      }

      this.$set(this, 'isLinkEnabled', true);
    },

    setIsSocialDisplayed() {
      if (POST_SOCIAL_ENABLED_TYPES.indexOf(this.activity.type) === -1) {
        return;
      }

      this.$set(this, 'isSocialDisplayed', true);
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";
@import "../activity";

.d-activity-entry {
  border-bottom: $border-width-base solid getColor($grey, medium);

  &.white {
    background-color: getColor($white);
    border-bottom: none;
    border-radius: $border-radius-lg;
    box-shadow: $box-shadow-base;
    margin: $_1em (-$_2em) 0;
    font-size: $font-size-sm;

    @include screenMoreThan(sm) {
      font-size: $font-size-base;
    }

    .social-container {
      padding: $_1em $_2em $_2em;
    }
  }

  .d-activity-activity,
  .d-activity-repost {
    @include activityStyling();
  }

  .activity-container {
    padding: $_2em $_2em 0;

    &.linked {
      cursor: pointer;
    }
  }

  .comment-box {
    background-color: getColor($white);
    border: $border-width-base solid getColor($grey, medium);
    border-radius: $border-radius-lg;
    font-style: italic;
    margin-bottom: $_2em;
    padding: $_2em;
  }

  .original-activity {
    margin-top: $_2em;
  }
}
</style>
